/* Utils */
import { useEffect, useState } from 'react';

/* Store */
import useModalStore from 'Stores/Modals';

/* Components */
import Modal from 'Components/Modal';

/* Styles */
import './style.scss';

const Welcome = () => {
	const hideModal = useModalStore(state => state.hideModal);
	const [navigation, setNavigation] = useState({ icon: '', action: () => null });
	const [button, setButton] = useState({ label: 'Next', action: null });

	useEffect(() => {
		setNavigation({ icon: '', action: () => null });
		setButton({ label: 'Done', action: () => hideModal() });
	}, []);

	return (
		<Modal title="Welcome" navigation={navigation} button={button}>
			<div className="default-modal wrapper">
				<div className="default-modal-content">
					<span className="header2">Default modal</span>
					<p className="bodyBullet">
						Hello this is default modal
					</p>
				</div>
			</div>
		</Modal>
	);
};

export default Welcome;
